<template>
	<div class="score-question">
		<div class="question-top">
			<span class="eyebrow">{{ question }}</span>
			<h3>{{ title }}</h3>
		</div>
		<div class="question-bottom">
			<div v-if="score" class="score">
				<span class="eyebrow">Your Score</span>
				<div class="score-card-total" :class="type">
					<span class="score-card-result">{{ score }}</span>
					<span class="score-card-total-max">/ 10</span>
				</div>
			</div>
			<div v-if="feedback && feedback !== 'Skipped'" class="feedback" :class="{ 'feedback-no-score': !score }">
				<span class="eyebrow">Your Feedback</span>
				<p>{{ feedback }}</p>
			</div>
		</div>
	</div>
</template>

<script>
// import ScoreHappyIcon from '@/assets/score-happy.svg';
export default {
	name: 'ScoreQuestion',
	props: {
		type: String,
		score: String,
		title: String,
		question: String,
		feedback: String,
		routeName: String
	},
	components: {}
};
</script>

<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	.score-question {
	    box-shadow: 5px 15px 15px 5px #EEF0F3;
	    text-align: left;
	    margin-bottom: 14px;
	    border-radius: 12px;
	    border: 1px solid #EEF0F3;
	    .question-top {
	    	position: relative;
			padding: 17px;
			border-radius: 12px 12px 0 0;
			display: flex;
			justify-content: space-between;
			background: #FFFFFF;
			flex-direction: column;
			border-bottom: 1px solid $snow;
	    }
	    .question-bottom {
	    	position: relative;
			padding: 17px;
			border-radius: 0 0 12px 12px;
			display: flex;
			justify-content: space-between;
			background: #FFFFFF;
			flex-direction: column;
			p {
				font-size: 14px;
				letter-spacing: -0.41px;
				line-height: 19px;
				color: #475668;
			}
	    }
		h3 {
			font-size: 17px;
		    letter-spacing: -0.5px;
		    line-height: 20px;
		    color: $dark;
		    font-weight: 600;
		    margin-bottom: 0;
		}
		.feedback {
			margin-top: 20px;
		}
        .feedback-no-score {
            margin-top: 0;
        }
		.score-card-total {
			font-weight: 600;
			color: $sky_base;
			font-size: 40px;
			letter-spacing: -1.18px;
			line-height: 24px;
			margin: 12px 0 0px;
			&.happy {
				color: $green_base;
			}
			&.average {
				color: $yellow_base;
			}
			&.sad {
				color: $red_base;
			}
			.score-card-total-max {
				font-size: 26px;
				letter-spacing: -0.76px;
				opacity: 0.7;
				margin-left: 10px;
			}
		}
	}
</style>
